import React, { useState } from 'react';
import { Card, Table, Form, Select, Button, Badge, Typography, Tag, message } from 'antd';
import { useTableRequest } from '@/hooks';
import {
  getProviderDeviceList,
  ProviderDeviceQueryResponse,
} from '@/api/customer';
import { getProviderUsers } from '@/api/workorder';
import { getDevice } from '@/api';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import BindModal from '../customer/BindModal';

const { Text } = Typography;

const statusMap: Record<number, { color: string; label: string }> = {
  1: { color: 'green', label: '绑定中' },
  0: { color: 'gray', label: '已解绑' },
};

const serviceTypeMap: Record<string, { color: string; label: string }> = {
  install: { color: 'blue', label: '安装' },
  maintain: { color: 'cyan', label: '维护' },
  repair: { color: 'orange', label: '维修' },
};

const ProviderDevicePage: React.FC = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [bindOpen, setBindOpen] = useState(false);

  const { data: deviceData } = useRequest(getDevice, { defaultParams: [{ isAll: true }] });
  const { data: providerData, refresh: refreshProviders } = useRequest(getProviderUsers, { manual: true });

  const { loading, dataSource, pagination, form, reload, search, reset } = useTableRequest<ProviderDeviceQueryResponse>({
    onRequest: (params) => {
      return getProviderDeviceList(params);
    },
  });

  return (
    <>
      {contextHolder}
      <Form layout="inline" className="ml20 mt20" form={form}>
        <Form.Item key="providerId" name="providerId">
          <Select
            placeholder="选择服务商"
            style={{ width: 160 }}
            allowClear
            showSearch
            optionFilterProp="label"
            options={(providerData?.result || []).map((p: any) => ({
              value: p.id,
              label: p.nickName || p.username,
            }))}
            onFocus={() => refreshProviders()}
          />
        </Form.Item>
        <Form.Item key="deviceId" name="deviceId">
          <Select
            options={deviceData?.result?.list || []}
            allowClear
            showSearch
            optionFilterProp="name"
            placeholder="选择设备"
            style={{ width: 160 }}
            fieldNames={{ label: 'name', value: 'id' }}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={search}>查询</Button>
        </Form.Item>
        <Form.Item>
          <Button type="default" onClick={reset}>重置</Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={() => setBindOpen(true)}>绑定设备</Button>
        </Form.Item>
      </Form>

      <Card className="m20" size="small">
        <Table
          loading={loading}
          dataSource={dataSource}
          pagination={pagination}
          rowKey="id"
          size="small"
          columns={[
            {
              title: '服务商ID',
              key: 'providerId',
              dataIndex: 'providerId',
              width: 200,
              ellipsis: true,
            },
            {
              title: '设备名称',
              key: 'deviceName',
              dataIndex: 'deviceName',
              width: 150,
              render: (value) => value || '-',
            },
            {
              title: '设备ID',
              key: 'deviceId',
              dataIndex: 'deviceId',
              width: 200,
              ellipsis: true,
            },
            {
              title: '服务类型',
              key: 'serviceType',
              dataIndex: 'serviceType',
              width: 80,
              render: (value) => {
                const s = serviceTypeMap[value];
                return s ? <Tag color={s.color}>{s.label}</Tag> : value || '-';
              },
            },
            {
              title: '绑定时间',
              key: 'bindTime',
              dataIndex: 'bindTime',
              width: 160,
              render: (value) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-'),
            },
            {
              title: '状态',
              key: 'status',
              dataIndex: 'status',
              width: 80,
              render: (value) => {
                const s = statusMap[value];
                return s ? (
                  <>
                    <Badge color={s.color} />
                    <Text className="ml5">{s.label}</Text>
                  </>
                ) : '-';
              },
            },
          ]}
        />
      </Card>

      <BindModal
        open={bindOpen}
        type="provider"
        onClose={() => setBindOpen(false)}
        onSuccess={() => { reload(); setBindOpen(false); }}
      />
    </>
  );
};

export default ProviderDevicePage;
